import { render, staticRenderFns } from "./roleTable.vue?vue&type=template&id=23267ca9&scoped=true&"
import script from "./roleTable.vue?vue&type=script&lang=js&"
export * from "./roleTable.vue?vue&type=script&lang=js&"
import style0 from "./roleTable.vue?vue&type=style&index=0&id=23267ca9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23267ca9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\code\\gongfeng\\CVSCRM_CODE\\scrm_manage_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('23267ca9')) {
      api.createRecord('23267ca9', component.options)
    } else {
      api.reload('23267ca9', component.options)
    }
    module.hot.accept("./roleTable.vue?vue&type=template&id=23267ca9&scoped=true&", function () {
      api.rerender('23267ca9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/web/market/activeDZP/roleTable.vue"
export default component.exports